





























import {
  computed, defineComponent, ref, toRefs,
} from '@nuxtjs/composition-api';
import { mixin as clickaway } from 'vue-clickaway';

import { ISortowania } from '~/types/ISortowania';

import { IMiasta } from '../filtry/types/IMiasta';
import icon from './icon.vue';

export default defineComponent({
  components: { icon },
  mixins: [clickaway],

  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    options: Array,
    // todo: add types na options
    value: {
      type: Object,
      required: true,
    },
    keyName: {
      type: String,
      required: true,
    },
    valueName: { type: String, required: true },
    skad: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selectOpen = ref(false);
    const { value, keyName } = toRefs(props);

    const isActiveValue = computed(
      () => (option: ISortowania | IMiasta): boolean | undefined => value.value && value.value[keyName.value || ''] === option[keyName.value || ''],
    );
    const isDisabled = computed(
      () => (option: IMiasta): boolean => !option?.CzyAktywny,
    );

    const acceptOption = (option: ISortowania | IMiasta) => {
      if ('CzyAktywny' in option && !option.CzyAktywny) return;

      selectOpen.value = false;
      emit('input', option);
    };

    return {
      closeSelect() {
        selectOpen.value = false;
      },
      acceptOption,
      selectOpen,
      isActiveValue,
      isDisabled,
    };
  },
});
